const origin = window.location.origin || 'http://localhost:8082';

const config = {
  API_URL: `${origin}/api`
};

export default config;
